import React from "react";
import bina from "../img/bina.jpeg";

const HomeContact = () => {
	return (
		<div className="paper" id="iletisim">
			<div className="container">
				<div className="row">
					<div className="col-sm-12 text-center pt-5">
						<i className="far fa-comments contact-icon text-primary" />
					</div>
				</div>
				<p className="fs-4  text-center my-3">
					En etkili iletişim samimiyettir.
				</p>

				<div className="contact-form radius-40">
					<div className="row pb-5">
						<div className="col-lg-6">
							<div className="d-flex justify-content-center align-item-center">
								<img
									src={bina}
									className="px-1 my-2 radius-20  img-fluid"
									alt="..."
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="mt-3">
								<div className="form-floating mb-3">
									<input
										type="email"
										className="form-control"
										id="floatingInput"
										placeholder="name@example.com"
									/>
									<label for="floatingInput">İsim Soyisim</label>
								</div>
								<div className="form-floating mb-3">
									<input
										type="email"
										className="form-control"
										id="floatingInput"
										placeholder="name@example.com"
									/>
									<label for="floatingInput">Email</label>
								</div>
								<div className="form-floating mb-3">
									<input
										type="email"
										className="form-control"
										id="floatingInput"
										placeholder="name@example.com"
									/>
									<label for="floatingInput">Telefon</label>
								</div>

								<div className="form-floating">
									<textarea
										className="form-control"
										placeholder="Leave a comment here"
										id="floatingTextarea2"
										style={{ height: "200px" }}
									></textarea>
									<label for="floatingTextarea2">Mesaj Yazınız</label>
								</div>
								<button className="btn btn-primary btn-lg mt-4 text-white">
									{" "}
									<i className="fas fa-paper-plane me-3 text-white" />
									MESAJI GÖNDER
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HomeContact;
